export const windowProviderDebug = (providerId, message) => {
    // make sure window has been defined
    if (!window.mosaic) {
        console.log('Window.mosaic not defined');
        return;
    }
    // if the user isn't logged into VPN then don't add debug information
    if (!window.mosaic.privileged) {
        return;
    }
    window.mosaic.debug = window.mosaic.debug || {};
    window.mosaic.debug[providerId] = window.mosaic.debug[providerId] || [];
    window.mosaic.debug[providerId].push(message);
};
